/**
 * Effect creator
 * Create an effect to use with epics
 *
 * redux-observable epics docs: https://redux-observable.js.org/docs/basics/Epics.html
 * Effect docs: https://redux-saga.js.org/docs/basics/DeclarativeEffects.html
 *
 * @param {String} type Effect name
 * @param {any} meta Additional data
 * @return {Object}
 */
export const createEffect = (type) => (meta) => ({
    type,
    meta,
});
